import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getActivityCountersRequest = {};
var _getActivityCountersResponse = {};
var _incrementActivityCountersRequest = {};
var _incrementActivityCountersResponse = {};
var _queryActivityCountersRequest = {};
var _queryActivityCountersResponse = {};
var _setActivityCountersRequest = {};
var _setActivityCountersResponse = {};
function resolveComWixpressMembersActivitycountersActivityCountersUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/activity-counters-api',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/members/v1/activity-counters',
                destPath: '/v1/activity-counters',
            },
        ],
        _: [
            {
                srcPath: '/_api/members/v1/activity-counters',
                destPath: '/v1/activity-counters',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/members/v1/activity-counters',
                destPath: '/v1/activity-counters',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/members/v1/activity-counters',
                destPath: '/v1/activity-counters',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/members/v1/activity-counters',
                destPath: '/v1/activity-counters',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/members/v1/activity-counters',
                destPath: '/v1/activity-counters',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/members/v1/activity-counters',
                destPath: '/v1/activity-counters',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/members/v1/activity-counters',
                destPath: '/v1/activity-counters',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Sets activity counters for a requested site member.
 *
 * If the counter does not already exist, it will be created.
 *
 * Counters are identified with a custom key, which must be unique.
 *
 * > **Note**: Make sure to pass a `memberId` and not a `contactId` to identify the member. Any relationship between a member's `memberId` and `contactId` is coincidental.
 */
export function setActivityCounters(payload) {
    var _a = serializer(_setActivityCountersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setActivityCountersResponse, {}).fromJSON;
    function __setActivityCounters(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.activity_counter',
            method: 'PUT',
            methodFqn: 'com.wixpress.members.activitycounters.ActivityCounters.SetActivityCounters',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersActivitycountersActivityCountersUrl({
                protoPath: '/v1/activity-counters/{memberId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setActivityCounters.fromReq = fromReq;
    __setActivityCounters.__isAmbassador = true;
    return __setActivityCounters;
}
/**
 * Increments a specific activity counters for a specified site member.
 *
 * If the counter does not already exist, it will be created.
 *
 * Counters are identified with a custom key, which must be unique.
 *
 * > **Note**: Make sure to pass a `memberId` and not a `contactId` to identify the member. Any relationship between a member's `memberId` and `contactId` is coincidental.
 */
export function incrementActivityCounters(payload) {
    var _a = serializer(_incrementActivityCountersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_incrementActivityCountersResponse, {}).fromJSON;
    function __incrementActivityCounters(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.activity_counter',
            method: 'PUT',
            methodFqn: 'com.wixpress.members.activitycounters.ActivityCounters.IncrementActivityCounters',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersActivitycountersActivityCountersUrl({
                protoPath: '/v1/activity-counters/{memberId}/increment',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __incrementActivityCounters.fromReq = fromReq;
    __incrementActivityCounters.__isAmbassador = true;
    return __incrementActivityCounters;
}
/**
 * Retrieves activity counters for the specified site member, including all public counters and any private counters owned by the authenticated caller.
 *
 * > **Note**: Make sure to pass a `memberId` and not a `contactId` to identify the member. Any relationship between a member's `memberId` and `contactId` is coincidental.
 */
export function getActivityCounters(payload) {
    var _a = serializer(_getActivityCountersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getActivityCountersResponse, {}).fromJSON;
    function __getActivityCounters(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.activity_counter',
            method: 'GET',
            methodFqn: 'com.wixpress.members.activitycounters.ActivityCounters.GetActivityCounters',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersActivitycountersActivityCountersUrl({
                protoPath: '/v1/activity-counters/{memberId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getActivityCounters.fromReq = fromReq;
    __getActivityCounters.__isAmbassador = true;
    return __getActivityCounters;
}
/**
 * Returns up to 100 public activity counters for the provided filter and paging.
 *
 * Only counters that are marked as public are returned.
 *
 * Supported fields for filtering:
 * - `memberId`
 *
 * Supported operations:
 *
 * Comparison:
 * - $eq
 * - $ne
 * - $in
 *
 * Logical:
 * - $and
 * - $not
 * - $or
 */
export function queryActivityCounters(payload) {
    var _a = serializer(_queryActivityCountersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryActivityCountersResponse, {}).fromJSON;
    function __queryActivityCounters(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.activity_counter',
            method: 'POST',
            methodFqn: 'com.wixpress.members.activitycounters.ActivityCounters.QueryActivityCounters',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersActivitycountersActivityCountersUrl({
                protoPath: '/v1/activity-counters/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryActivityCounters.fromReq = fromReq;
    __queryActivityCounters.__isAmbassador = true;
    return __queryActivityCounters;
}
//# sourceMappingURL=http.impl.js.map